import { HttpService } from "../../modules/shared/services/http.service";
import { 
	Deposit, 
	DepositCreateDto, 
	DepositBackendResponse,
	DepositRule, 
	DepositRuleCreateDto, 
	DepositRuleUpdateDto,
	DepositException,
	DepositExceptionCreateDto,
	DepositExceptionUpdateDto,
	DepositRuleBackendResponse,
	DepositExceptionBackendResponse
} from "../../modules/shared/model/deposit.interfaces";

const headers = { "Content-Type": "application/json", "x-custom-lang": "en" } as const;

// Main Deposit Actions
export const createDeposit = async (data: DepositCreateDto): Promise<DepositBackendResponse> => {
	const response = await HttpService.post("api/v1/deposits", data, headers, true);
	return response;
};

export const updateDeposit = async (id: string, data: Partial<DepositCreateDto>): Promise<DepositBackendResponse> => {
	const response = await HttpService.patch(`api/v1/deposits/${id}`, data, headers, true);
	return response;
};

export const getDepositById = async (id: string): Promise<DepositBackendResponse> => {
	const response = await HttpService.get(`api/v1/deposits/${id}`, true, { "x-custom-lang": "en" });
	return response;
};

export const getDeposits = async (query?: Record<string, string | number | boolean>): Promise<{ data: DepositBackendResponse[]; totalCount?: number }> => {
	const qs = new URLSearchParams();
	Object.entries(query || {}).forEach(([k, v]) => {
		if (v !== undefined && v !== null) qs.append(k, String(v));
	});
	const response = await HttpService.get(`api/v1/deposits${qs.toString() ? `?${qs}` : ""}`, true, { "x-custom-lang": "en" });
	return response;
};

export const deleteDeposit = async (id: string): Promise<void> => {
	await HttpService.deleteRecord(`api/v1/deposits/${id}`, { "x-custom-lang": "en" }, true);
};

export const getDepositStats = async (): Promise<{
	activeRules: number;
	avgDeposit: number;
	holdTime: number;
	successRate: number;
}> => {
	const response = await HttpService.get("api/v1/deposits/stats", true, { "x-custom-lang": "en" });
	return response;
};

// Deposit Rule Actions
export const createDepositRule = async (data: DepositRuleCreateDto): Promise<DepositRuleBackendResponse> => {
	const response = await HttpService.post("api/v1/deposit-rules", data, headers, true);
	return response;
};

export const updateDepositRule = async (id: string, data: DepositRuleUpdateDto): Promise<DepositRuleBackendResponse> => {
	const response = await HttpService.patch(`api/v1/deposit-rules/${id}`, data, headers, true);
	return response;
};

export const getDepositRuleById = async (id: string): Promise<DepositRuleBackendResponse> => {
	const response = await HttpService.get(`api/v1/deposit-rules/${id}`, true, { "x-custom-lang": "en" });
	return response;
};

export const getDepositRules = async (query?: Record<string, string | number | boolean>): Promise<{ data: DepositRuleBackendResponse[]; totalCount?: number }> => {
	const qs = new URLSearchParams();
	Object.entries(query || {}).forEach(([k, v]) => {
		if (v !== undefined && v !== null) qs.append(k, String(v));
	});
	const response = await HttpService.get(`api/v1/deposit-rules${qs.toString() ? `?${qs}` : ""}`, true, { "x-custom-lang": "en" });
	return response;
};

export const deleteDepositRule = async (id: string): Promise<void> => {
	await HttpService.deleteRecord(`api/v1/deposit-rules/${id}`, { "x-custom-lang": "en" }, true);
};

// Deposit Exception Actions
export const createDepositException = async (data: DepositExceptionCreateDto): Promise<DepositExceptionBackendResponse> => {
	const response = await HttpService.post("api/v1/deposit-exceptions", data, headers, true);
	return response;
};

export const updateDepositException = async (id: string, data: DepositExceptionUpdateDto): Promise<DepositExceptionBackendResponse> => {
	const response = await HttpService.patch(`api/v1/deposit-exceptions/${id}`, data, headers, true);
	return response;
};

export const getDepositExceptionById = async (id: string): Promise<DepositExceptionBackendResponse> => {
	const response = await HttpService.get(`api/v1/deposit-exceptions/${id}`, true, { "x-custom-lang": "en" });
	return response;
};

export const getDepositExceptions = async (query?: Record<string, string | number | boolean>): Promise<{ data: DepositExceptionBackendResponse[]; totalCount?: number }> => {
	const qs = new URLSearchParams();
	Object.entries(query || {}).forEach(([k, v]) => {
		if (v !== undefined && v !== null) qs.append(k, String(v));
	});
	const response = await HttpService.get(`api/v1/deposit-exceptions${qs.toString() ? `?${qs}` : ""}`, true, { "x-custom-lang": "en" });
	return response;
};

export const deleteDepositException = async (id: string): Promise<void> => {
	await HttpService.deleteRecord(`api/v1/deposit-exceptions/${id}`, { "x-custom-lang": "en" }, true);
};

